// Firebase Configuration
// TODO: Replace with your Firebase project configuration
// Get these values from Firebase Console > Project Settings > General > Your apps

import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';

// Firebase configuration object
// Replace these values with your actual Firebase project config
const firebaseConfig = {
  apiKey: "AIzaSyDQfaDGoe3IxiSwWVTtxZjt19uDxAfcDxo",
  authDomain: "edsha-f4861.firebaseapp.com",
  projectId: "edsha-f4861",
  storageBucket: "edsha-f4861.firebasestorage.app",
  messagingSenderId: "912524653506",
  appId: "1:912524653506:web:1574a9b4480f0d62bb5c5b",
  measurementId: "G-KJSGGSWLZB"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Cloud Messaging and get a reference to the service
let messaging = null;
let messagingInitialized = false;

// Initialize messaging with service worker
async function initializeMessaging() {
  if (messagingInitialized || typeof window === 'undefined' || !('serviceWorker' in navigator)) {
    return messaging;
  }

  try {
    // Register service worker first
    const registration = await navigator.serviceWorker.register('/firebase-messaging-sw.js');
    console.log('[FIREBASE] Service Worker registered:', registration);
    
    // Initialize messaging with service worker
    messaging = getMessaging(app, {
      serviceWorkerRegistration: registration
    });
    messagingInitialized = true;
    return messaging;
  } catch (error) {
    console.error('[FIREBASE] Service Worker registration failed:', error);
    // Fallback: try without explicit registration
    try {
      messaging = getMessaging(app);
      messagingInitialized = true;
      return messaging;
    } catch (err) {
      console.error('[FIREBASE] Firebase Messaging initialization error:', err);
      return null;
    }
  }
}

// Initialize on load
if (typeof window !== 'undefined' && 'serviceWorker' in navigator) {
  initializeMessaging().catch(err => {
    console.error('[FIREBASE] Failed to initialize messaging:', err);
  });
}

/**
 * Request notification permission and get FCM token
 * @returns {Promise<string|null>} FCM token or null if permission denied or error
 */
export const getFCMToken = async () => {
  // Ensure messaging is initialized
  if (!messaging && !messagingInitialized) {
    await initializeMessaging();
  }

  if (!messaging) {
    console.warn('[FIREBASE] Firebase Messaging is not available');
    return null;
  }

  try {
    // Request notification permission
    const permission = await Notification.requestPermission();
    
    if (permission === 'granted') {
      // Get FCM token
      // VAPID key is required for web push notifications
      const vapidKey = "BEW_4mPmhEnfccqKL3__ZVUF3uAm2EqoCU5EMJ3saeIUpUoD-in4L82-Ayrxs_aKjjcaX1OVtKekahhjCYiCI9U";
      
      const currentToken = await getToken(messaging, { vapidKey });
      
      if (currentToken) {
        console.log('[FIREBASE] FCM Token obtained:', currentToken);
        return currentToken;
      } else {
        console.warn('[FIREBASE] No FCM token available. Request permission to generate one.');
        return null;
      }
    } else {
      console.warn('[FIREBASE] Notification permission denied');
      return null;
    }
  } catch (error) {
    console.error('[FIREBASE] An error occurred while retrieving FCM token:', error);
    return null;
  }
};

/**
 * Set up foreground message handler
 * This handles notifications when the app is in the foreground
 */
export const onMessageListener = () => {
  if (!messaging) {
    return Promise.reject('Firebase Messaging is not available');
  }
  
  return new Promise((resolve) => {
    onMessage(messaging, (payload) => {
      console.log('Message received in foreground:', payload);
      resolve(payload);
    });
  });
};

export { messaging };
export default app;

